<template>
  <div class="SX-container">
    <div class="BigImg">
      <div class="videoBox">
        <video ref="video" src=" 
            https://video.wezhan.cn/d0bedd113f6071efaf686732b78e0102/54ef96935f25423d9b632afcceeff6b2-6691935feffdcdecd044d33f2ac422a1-sd.mp4?auth_key=1720686759-69fab1c3a7e748d084ef285a6b1563d2-0-5a871488364fa949fe1370fa944b4321
            " poster="../../assets/数字镖局bj.jpg" :controls="!isPlay"></video>
        <div class="videoBtn" @click="handleshow">
          <i class="iconfont icon-bofang"></i>
        </div>
      </div>
      <div class="BigImg-r">
        <div class="Text">
          <p class="Text-title">数匣</p>
          <p>个人数据空间</p>
        </div>
        <!-- <div class="QR">
          <img src="../../assets/QR.png" alt="">
          <p>扫码下载</p>
        </div> -->
      </div>
    </div>
    <ViewContentImg :list="data1"/>
    <ViewContentVue :list="data2"/>
  </div>
</template>

<script>
import { Message } from 'element-ui';
import ViewContentVue from '@/components/ViewContent.vue'
import ViewContentImg from '@/components/ViewContentImg'
// import img1 from "@/assets1/数匣_slices/位图.png"
// import img2 from "@/assets1/数匣_slices/位图1.png"
// import img3 from "@/assets1/数匣_slices/安全承诺.png"
// import img4 from "@/assets1/数匣_slices/区块链存证.png"
export default {
data(){
  return{
    isPlay:true,
    data1:[{title:'个人数据安全匣子',
    content:'数匣为每一个用户提供其专属的个人数据空间，用户的数据在上传前，会使用其专属的密钥进行加密。加密后的数据将上传至数匣的保险箱中，仅用户本人及其授权的用户才能查看。',
    height:'414px',
    type:'left',width:'450px',
    img:'https://sxoffcia.oss-cn-chengdu.aliyuncs.com/offcia_Img/%E6%95%B0%E5%8C%A3/%E4%BD%8D%E5%9B%BE.png',fontColor:'#000',color:'#fff'}],

      data2:[
      {title:'多格式数据兼容',
    content:'数匣支持各类照片、音频、视频、文档、压缩包、文件夹等常见数据，同时数匣也支持结构化数据的存储，满足个人用户的各种需求。',
    height:'414px',width:'450px',img:'https://sxoffcia.oss-cn-chengdu.aliyuncs.com/offcia_Img/%E6%95%B0%E5%8C%A3/%E5%AE%89%E5%85%A8%E6%89%BF%E8%AF%BA.png',
    type:'right',color:'#fff',fontColor:'#000',
    },
    {title:'永久存储——永续存',
    content:'担心你珍藏的家人的照片会不慎遗失？害怕你家族的族谱？不再相信互联网存在记忆？ 别担心，数匣永续存将提供永久存储服务，所有您珍视的数据，都将被数匣妥善保存，保证永远可存、可读、可取。',
    height:'414px',width:'450px',
    type:'left',img:'https://sxoffcia.oss-cn-chengdu.aliyuncs.com/offcia_Img/%E6%95%B0%E5%8C%A3/%E4%BD%8D%E5%9B%BE1.png',fontColor:'#000',
    },
    {title:'区块链存证',
    content:'用户将本地文件（数据）上传至数字镖局，上传的数据会通过数匣的区块链进行产权登记，保护用户数据的权益。',
    content2:'数匣可以通过区块链技术实现数据资产的标准化，建立统一的数据字典，形成基于区块链的数据图谱。',
    height:'414px',width:'450px',img:'https://sxoffcia.oss-cn-chengdu.aliyuncs.com/offcia_Img/%E6%95%B0%E5%8C%A3/%E5%8C%BA%E5%9D%97%E9%93%BE%E5%AD%98%E8%AF%81.png',
    type:'right',color:'#fff',fontColor:'#000',
    }
    ]
  }
},
components:{
  ViewContentVue,ViewContentImg
},
methods:{
  handleshow(){
    Message({
          message: '敬请期待',
          type: 'warning'
        });
  }
}
}
</script>

<style scoped>
.Text{
  font-family: Light;
font-weight: 400;
font-size: 24px;
color: #FFFFFF;
line-height: 46px;
}
.BigImg{
  min-width:1920px ;
  height: 670px;
  background-image: url('https://sxoffcia.oss-cn-chengdu.aliyuncs.com/offcia_Img/%E6%95%B0%E5%8C%A3/%E5%85%B3%E4%BA%8E%E6%88%91%E4%BB%ACbanner.png');
  position: relative;
  background-size: cover;
}
.videoBox{
  left: 360px;
  top: 200px;
  position: absolute;
width: 622px;
height: 350px;border-radius: 20px;
background-color: rgba(255, 255, 255, 0.3);
padding: 3px;
}
video{
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 20px;
}
.videoBtn{
  width: 83px;height: 83px;
  border-radius: 50%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  background-color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
}
.icon-bofang{
  font-size: 35px;
   position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  background-color: rgba(255, 255, 255, 0.8);
}
.Text-title{
  font-family: Heavy;
font-weight: 800;
font-size: 40px;
color: #FFFFFF;
line-height: 55px;
margin-bottom: 10px;
}
.BigImg-r{
   left:1148px;
  top: 214px;
  position: absolute;
}
.QR img{
  width: 110px;
  height: 110px;
  object-fit: cover;
  display: block;
  margin-bottom: 14px;
}
.QR{
  margin-top: 60px;
  font-family: Light;
font-weight: 400;
font-size: 14px;
color: rgba(255, 255, 255, .6);
line-height: 20px;
text-align: center;
width: 110px;
}
</style>